import React from 'react';
import { Hexagon, Mail, Clock } from 'lucide-react';
import { MONTHLY } from '../lib/pricing';

const ComingSoonPage = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <Hexagon className="w-12 h-12 text-primary fill-primary/20" />
          <span className="font-heading font-bold text-3xl">HolidayHive</span>
        </div>
        
        {/* Coming Soon Badge */}
        <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
          <Clock className="w-4 h-4" />
          <span className="font-medium">Coming Soon</span>
        </div>
        
        {/* Main Message */}
        <h1 className="text-4xl font-heading font-bold mb-4">
          Something amazing is brewing
        </h1>
        
        <p className="text-muted-foreground text-lg mb-8">
          We're working hard to bring you the simplest way to manage staff holidays. 
          Stay tuned for our launch!
        </p>
        
        {/* Features Preview */}
        <div className="grid grid-cols-1 gap-4 mb-8 text-left">
          <div className="bg-card rounded-lg p-4 border border-border">
            <p className="font-medium">Simple holiday requests & approvals</p>
          </div>
          <div className="bg-card rounded-lg p-4 border border-border">
            <p className="font-medium">Team wallchart & calendar views</p>
          </div>
          <div className="bg-card rounded-lg p-4 border border-border">
            <p className="font-medium">Just {MONTHLY} per user per month</p>
          </div>
        </div>
        
        {/* Contact */}
        <div className="flex items-center justify-center gap-2 text-muted-foreground">
          <Mail className="w-4 h-4" />
          <span>Questions? Contact us at hello@holidayhive.co.uk</span>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
